import { useRef } from 'react';

/**
 * Latches on the first render `value` is true and stays true for the life of the component.
 *
 * For a decision that belongs to the session rather than to whichever request happens to be in
 * flight. `appShowCsw` is one: it is driven by an A/B variant that every client-side config
 * refetch re-resolves from scratch, so a single request that cannot reach SAAB reads as the
 * control arm and would take the app header away from a user who had it a moment earlier
 * (MPH-1123). Withdrawing a feature mid-session is never the right answer to one bad request -
 * the user has already been bucketed and has already seen it.
 */
export const useLatchedTrue = (value: boolean): boolean => {
  const latched = useRef(false);
  latched.current = latched.current || value;
  return latched.current;
};
